import { makeStyles, shorthands } from '@fluentui/react-components';

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    backgroundColor: '#ffffff',
    overflow: 'hidden',
    minWidth: 0,
    boxSizing: 'border-box',
    fontFamily: 'Roboto, sans-serif',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.padding('20px', '24px'),
    backgroundColor: '#ffffff',
    flexShrink: 0,
    width: '100%',
    boxSizing: 'border-box',
    ...shorthands.gap('16px'),
  },
  headerTop: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  title: {
    fontSize: '24px',
    fontWeight: '600',
    color: '#1a1a1a',
  },
  content: {
    flex: 1,
    ...shorthands.padding('0', '24px', '24px'),
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
  },
  sectionTitle: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#1a1a1a',
  },
  sectionDescription: {
    fontSize: '13px',
    lineHeight: '18px',
    color: '#666666',
    marginBottom: '16px',
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    ...shorthands.gap('12px'),
    marginBottom: '16px',
  },
  permissionList: {
    margin: '14px 0 0 0',
    paddingLeft: '18px',
    color: '#333333',
    fontSize: '11px',
    lineHeight: '16px',
    '& li': {
      paddingLeft: '2px',
      marginBottom: '20px',
    },
    '& li:last-child': {
      marginBottom: 0,
    },
  },
  setupSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
  },
  setupActions: {
    marginTop: '16px',
  },
  setupButton: {
    minHeight: '29px',
    height: '29px',
    padding: '0 11px',
    fontFamily: 'Roboto, sans-serif',
    fontSize: '11px',
    fontWeight: '400',
  },
  tableWrapper: {
    width: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
    ...shorthands.border('1px', 'solid', '#e0e0e0'),
    ...shorthands.borderRadius('8px'),
  },
  table: {
    width: '100%',
    minWidth: '600px',
    tableLayout: 'fixed',
    borderCollapse: 'collapse',
    backgroundColor: '#ffffff',
  },
  tableHeaderRow: {
    backgroundColor: '#f8f8f8',
    borderBottom: '1px solid #e0e0e0',
    '& th': {
      ...shorthands.padding('12px', '16px'),
      textAlign: 'left',
      fontSize: '14px',
      fontWeight: '700',
      color: '#656565',
      textTransform: 'uppercase',
      letterSpacing: 'normal',
      lineHeight: '44.289px',
      whiteSpace: 'nowrap',
    },
  },
  emptyTableRow: {
    '& td': {
      ...shorthands.padding('16px'),
      textAlign: 'center',
      fontSize: '14px',
      color: '#1a1a1a',
    },
  },
  tableRow: {
    borderBottom: '1px solid #f0f0f0',
    ':nth-child(even)': {
      backgroundColor: '#f5f5f5',
    },
    '& td': {
      ...shorthands.padding('16px'),
      fontSize: '14px',
      color: '#1a1a1a',
      verticalAlign: 'top',
    },
  },
  rowNameButton: {
    ...shorthands.border('none'),
    backgroundColor: 'transparent',
    color: '#5051b1',
    fontFamily: 'Segoe UI, sans-serif',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    ...shorthands.padding('0'),
    textAlign: 'left',
    ':hover': {
      textDecorationLine: 'underline',
    },
  },
  policySummary: {
    lineHeight: '20px',
    overflowWrap: 'anywhere',
  },
  policiesCell: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap('4px'),
  },
  policiesNamesRow: {
    display: 'flex',
    alignItems: 'baseline',
    ...shorthands.gap('4px'),
  },
  overflowButton: {
    ...shorthands.border('none'),
    backgroundColor: 'transparent',
    color: '#666666',
    cursor: 'default',
    fontSize: '13px',
    lineHeight: '18px',
    ...shorthands.padding('0'),
  },
  policiesTotalLine: {
    color: '#666666',
    fontSize: '13px',
    lineHeight: '18px',
  },
  listError: {
    width: '100%',
    marginBottom: '16px',
  },
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...shorthands.padding('64px', '24px'),
  },
  enrollmentDialogSurface: {
    width: '600px',
    height: '200px',
    maxWidth: 'calc(100vw - 48px)',
    boxSizing: 'border-box',
    ...shorthands.padding('23px', '23px', '28px'),
    ...shorthands.borderRadius('8px'),
    boxShadow: '0 0 4px rgba(0, 0, 0, 0.2), 0 32px 64px rgba(0, 0, 0, 0.24)',
  },
  enrollmentDialogBody: {
    display: 'grid',
    gridTemplateRows: '32px minmax(0, 69px) 32px',
    rowGap: '8px',
    height: '149px',
    padding: 0,
  },
  enrollmentDialogTitle: {
    alignSelf: 'center',
    minHeight: '32px',
    fontFamily: 'Segoe UI, sans-serif',
    fontSize: '20px',
    fontWeight: '600',
    lineHeight: '28px',
    color: '#242424',
  },
  enrollmentDialogContent: {
    minWidth: 0,
    minHeight: 0,
    padding: 0,
    margin: 0,
    overflowY: 'auto',
  },
  enrollmentDialogDescription: {
    display: 'block',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#000000',
  },
  enrollmentLinkText: {
    display: 'flex',
    alignItems: 'center',
    height: '42px',
    maxWidth: '100%',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    userSelect: 'none',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#757575',
    marginTop: '3px',
  },
  enrollmentDialogActions: {
    alignSelf: 'stretch',
    alignItems: 'center',
    justifyContent: 'flex-end',
    ...shorthands.gap('8px'),
    height: '32px',
    margin: 0,
    padding: 0,
  },
  enrollmentDialogCancelButton: {
    minWidth: 'auto',
    height: '32px',
    ...shorthands.padding('5px', '12px'),
    ...shorthands.borderRadius('4px'),
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '20px',
  },
  enrollmentDialogCopyButton: {
    width: '102px',
    minWidth: '102px',
    maxWidth: '102px',
    height: '32px',
    ...shorthands.padding('5px', '9px'),
    ...shorthands.borderRadius('4px'),
    backgroundColor: '#5863c0',
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '20px',
    whiteSpace: 'nowrap',
    flexShrink: 0,
    '& .fui-Button__icon': {
      width: '16px',
      height: '16px',
      fontSize: '16px',
      flexShrink: 0,
      marginRight: '4px',
    },
  },
  copyLinkIcon: {
    fontSize: '16px',
  },
  visuallyHidden: {
    position: 'absolute',
    width: '1px',
    height: '1px',
    ...shorthands.padding('0'),
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    ...shorthands.border('0'),
  },
});